<app-swap-modal-note-item
  [note]="swap().note"
  [identifierColor]="isDouble() ? 'blue' : null"
></app-swap-modal-note-item>

@if (isDouble()) {
  <app-swap-modal-note-item
    [note]="swap().otherNote"
    identifierColor="sea-green"
  ></app-swap-modal-note-item>
}
